<ng-container *transloco="let translate">
    <div class="flex items-center justify-between w-full mx-auto px-4 py-2 pb-4">
        <h1 class="text-xl font-semibold" [textContent]="translate('Collaborators')"></h1>
        <material-button class="p-2 rounded-full" [buttonType]="'icon'" [size]="'small'" [titleText]="'Close'" [prefixIcon]="'close'" [classList]="['focus:!outline-none', 'hover:!bg-gray-100']" (buttonClicked)="closeModal()"></material-button>
    </div>
    <mat-dialog-content class="w-full h-[76%] overflow-auto px-4 py-2 relative !left-[15px]">
        <ng-container *ngIf="collaborators?.length > 0; else noCollaborators">
            <div class="w-full p-3 border-[1px] border-solid border-[#d8d8d8] mb-1" *ngFor="let collaborator of collaborators">
                <div class="row mb-2">
                    <div class="col-6 flex">
                        <span class="col-4 text-[#9c9c9c] truncate font-bold" [textContent]="translate('Partner Name')"></span>
                        <span class="col-8 truncate">
                            <b class="text-[#9c9c9c] mr-1">:</b>
                            <span [textContent]="collaborator.partnerName"></span>
                        </span>
                    </div>
                    <div class="col-6 flex">
                        <span class="col-4 text-[#9c9c9c] truncate font-bold" [textContent]="translate('Collaborator Type')"></span>
                        <span class="col-8 truncate">
                            <b class="text-[#9c9c9c] mr-1">:</b>
                            <span [textContent]="collaborator.collaboratorType"></span>
                        </span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-6 flex">
                        <span class="col-4 text-[#9c9c9c] truncate font-bold" [textContent]="translate('Partner Function')"></span>
                        <span class="col-8 truncate">
                            <b class="text-[#9c9c9c] mr-1">:</b>
                            <span [textContent]="collaborator.partnerFunction"></span>
                        </span>
                    </div>
                    <div class="col-6 flex">
                        <span class="col-4 text-[#9c9c9c] truncate font-bold" [textContent]="translate('Partner Id')"></span>
                        <span class="col-8 truncate">
                            <b class="text-[#9c9c9c] mr-1">:</b>
                            <span [textContent]="collaborator.partnerId"></span>
                        </span>
                    </div>
                </div>
            </div>
        </ng-container>
        <ng-template #noCollaborators>
            <div class="w-full text-center items-center">No collaborators found</div>
        </ng-template>
    </mat-dialog-content>
    <mat-dialog-actions class="!min-h-0 flex justify-center items-center max-h-[30px]">
        <material-button [text]="translate('Close')" (buttonClicked)="closeModal()"></material-button>
    </mat-dialog-actions>
</ng-container>
